export function Spinner({ isShowText }) {
    return <div className="flex align-center justify-center gap-1 column loader-page spinner">
        <div className='loader'><div></div><div></div><div></div><div></div></div>
        {isShowText && 'We are still gathering the data of your orders from Shopify, please wait a few more moments 🙂'}
    </div>
}